import React from 'react';
import { ILandingProduct } from 'types/marketplace';
import { Flex, P } from 'ui';
import { AppRoutes } from 'router';

import Blur from '../Blur';
import {
  AsicCardWrapper,
  AsicImg,
  AsicPreview,
  AsicTitle,
  AsicCollection,
  AttributeButton,
  AttributeIcon,
  AttributeItem,
  AttributeList,
  BagIcon,
  LeftWrap,
  SliderImgWrapper,
  TitlePrimary,
  TitleWrap,
} from '../../style';

type SliderItemPropsType = ILandingProduct;

const SliderItem: React.FC<SliderItemPropsType & { isActiveSlide: boolean }> = ({
  id: shortContractID,
  img,
  title,
  collectionName,
  price,
  roiPercent,
  btcReward,
  month_durability: monthDurability,
  isActiveSlide,
}) => (
  <AsicCardWrapper $active={isActiveSlide}>
    <LeftWrap>
      <SliderImgWrapper>
        <AsicImg src={img} alt={title} />
      </SliderImgWrapper>
      <Blur />

      <AsicTitle fontFamily="secondary" size="md" $isVisible={!isActiveSlide}>
        {title}
      </AsicTitle>
      <AsicCollection fontFamily="primary" size="sm" $isVisible={!isActiveSlide}>
        Liquid STC
      </AsicCollection>
    </LeftWrap>
    {isActiveSlide && (
      <AsicPreview>
        <TitleWrap>
          <div>
            <TitlePrimary fontFamily="secondary" size="md" align="left">
              {title}
            </TitlePrimary>
            <P fontFamily="primary" size="sm" color="secondary" align="left">
              {collectionName}
            </P>
          </div>
        </TitleWrap>
        <AttributeList>
          <AttributeItem>
            <AttributeIcon name="timer" />
            <P fontFamily="primary" size="md">
              {monthDurability} months
            </P>
          </AttributeItem>
          <AttributeItem>
            <AttributeIcon name="wallet" />
            <P fontFamily="primary" size="md">
              {roiPercent}%
            </P>
          </AttributeItem>
          <AttributeItem>
            <AttributeIcon name="coins" />
            <P fontFamily="primary" size="md">
              {btcReward} BTC
            </P>
          </AttributeItem>
        </AttributeList>
        <Flex $gap="sm" $align="stretch">
          <AttributeButton size="large" to={AppRoutes.SHORT_CONTRACTS} state={{ shortContractID }}>
            <Flex $gap="sm">
              {price} USDT
              <BagIcon name="bag" />
            </Flex>
          </AttributeButton>
        </Flex>
      </AsicPreview>
    )}
  </AsicCardWrapper>
);

export default SliderItem;
